// palette + bootstrap
export const theme = {
  aqua: '#1cc0fc',
  aquaLight: '#EDFAFF',
  aquaTranslucent: '#92e1fe2c',
  black: '#212529', // gray-900
  trueBlack: '#000000',
  blue: '#000848',
  /** Official MediaInbox logo / brand blue. */
  brandBlue: '#347bff',
  /** Official MediaInbox logo / brand green. */
  brandGreen: '#05d795',
  blueNew: '#337AFF', // New Figma blue for stepper/primary actions
  blueNewPastel: '#7DA8FF',
  green: '#08ecb8',
  greenDark: '#0ecfa3',
  greenSuccess: '#00AC77', // New Figma green for success states
  pink: '#ec0864',
  purple: '#AF52DE', // New Figma purple for primary buttons
  orange: '#ff7d55',
  red: '#fa5968',
  white: '#ffffff',
  yellow: '#d2e240',

  // New Figma gray scale
  grayNew100: '#F7F8F9',
  grayNew200: '#DDE1E6',
  grayNew300: '#D0D4D9',
  grayNew400: '#AAAFB6',
  grayNew500: '#636B75',
  grayNew600: '#838D95',
  grayNew950: '#0E0F11',

  // Legacy gray scale (keeping for backwards compatibility)
  gray100: '#f8f9fa',
  gray200: '#e9ecef',
  gray300: '#dee2e6',
  gray400: '#ced4da',
  gray500: '#adb5bd',
  gray600: '#6c757d',
  gray700: '#495057',
  gray800: '#343a40',
  gray900: '#212529',

  facebook: '#3b5998',
  twitter: '#55acee',
  google: '#dd4b39',
  whatsapp: '#128C7E',
};

export const palette = theme;

// https://coolors.co/gradient-palette
export const graphPalette = [
  '#2A1B4A',
  '#AA5651',
  '#552F4C',
  '#D69066',
  '#90D8F3',
  '#8E9FA9',
  '#ADA276',
  '#5BA5C2',
  '#8A4C27',
  '#7585E3',
  '#978744',
];

export const btnColors = [
  'primary',
  'secondary',
  'info',
  'success',
  'warning',
  'danger',
  'light',
  'blue',
  'pink',
  'purple',
  'yellow',
  'white',
];

export type themeColor = 'orange' | 'aqua' | 'green' | 'pink' | 'red' | 'yellow' | 'white';
